import CookieDb from './index.js';
class History extends CookieDb {
    defaults() {
        return {
            apiPath: '/api/history',
            cookieKeyName: 'histories',
            expires: 2, // 2日間有効
            secure: location.protocol === 'https:',
        };
    }
}

export default History;
